
export default function responseNotification (store, response, successMessage=null, config) {
  let rootVM = window.rootVM;

  if (response.error) {
    rootVM.$snotify.error(response.error, config)
  } else if (response.info){
    rootVM.$snotify.info(response.info, config)
  } else {
    rootVM.$snotify.success(successMessage || response.message, config)
  }
}



// WEBPACK FOOTER //
// ./src/lib/responseNotification.js